export var presetsTypes = {
    DEFAULT: 'DEFAULT',
    DS: 'DS',
    EDITOR: 'EDITOR',
    OOI: 'OOI',
    BOLT: 'BOLT',
    MOBILE: 'MOBILE',
};
//# sourceMappingURL=presets-types.js.map